import { put, takeLatest } from "@redux-saga/core/effects";
import { Notification } from "components/Notification/Noti";
import { loadRecordDataAPI } from "redux/api/objectsAPIs";
import {
  getRecordDetails,
  getRecordDetailsResult,
} from "redux/slices/consolidatedView";

export default function* ConsolidatedViewSaga() {
  yield takeLatest(getRecordDetails.type, GetRecordDetails);
}

function* GetRecordDetails(action) {
  try {
    const res = yield loadRecordDataAPI(action.payload);
    yield put(getRecordDetailsResult(res.data.data));
  } catch (error) {
    yield put(getRecordDetailsResult({}));
    Notification("error", error.response.data.error);
  }
}
